import React from 'react';
import cn from 'classnames';

import styles from './readonly-field.module.scss';

interface IReadonlyFieldProps {
  children: any;
  className?: string;
}

export default function ReadonlyField({ children, className }: IReadonlyFieldProps) {
  return (
    <div className={cn(styles.readonly, className)}>
      {children}
    </div>
  );
}
